<template>
  <v-select
    id="ad-select"
    v-model="filter.adId"
    item-text="nome"
    item-name="usuarioId"
    item-value="usuarioId"
    :items="users"
    label="AD"
    placeholder="AD"
  >
    <template slot="no-data">
      Nenhum AD retornado
    </template>
  </v-select>
</template>

<script>
import { userAPI } from './UserAPI'

export default {
  name: 'AppAdsCombobox',
  props: [
    'filter'
  ],
  mounted () {
    this.loadADs()
  },
  methods: {
    loadADs () {
      userAPI.listADs()
        .then(resp => {
          this.users = resp.data
        })
        .catch(resp => {
          this.$notification.error('Erro ao obter ADs')
        })
    }
  },
  data () {
    return {
      users: []
    }
  }
}
</script>
